var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_32433_962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99997 3V5C6.99997 5.55 7.44997 6 7.99997 6C8.54997 6 8.99997 5.55 8.99997 5V4H19V20H8.99997V19C8.99997 18.45 8.54997 18 7.99997 18C7.44997 18 6.99997 18.45 6.99997 19V21C6.99997 22.1 7.89997 23 8.99997 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1H8.99997C7.89997 1 6.99997 1.9 6.99997 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00001 12C9.28918 12 10.3333 10.9558 10.3333 9.66665C10.3333 8.37748 9.28918 7.33331 8.00001 7.33331C6.71084 7.33331 5.66668 8.37748 5.66668 9.66665C5.66668 10.9558 6.71084 12 8.00001 12ZM8.00001 13.1666C6.44251 13.1666 3.33334 13.9483 3.33334 15.5V16.6666H12.6667V15.5C12.6667 13.9483 9.55751 13.1666 8.00001 13.1666Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32433_962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceUsers);
export default __webpack_public_path__ + "static/media/device_users.32c664f756b30548824abee7da1a5756.svg";
export { ForwardRef as ReactComponent };